<template>
<div>
    <div
        style="display: flex; gap: 15px; margin-bottom: -10px"
    >
        <div
            style="flex-grow: 0px; width: 90px; height: 90px; position: relative; border: 1px solid rgba(0,0,0,0.3);"
        >
            <div
                style="height: 100%; line-height: 90px; text-align: center; overflow: hidden;"
            >
                <span
                    :style="value.style"
                >
                    Aa
                </span>
            </div>
        </div>

        <div
            style="flex-grow: 1"
        >
            <v-text-field
                :label="label"
                v-model="value.text"
                v-on:input="onChangeText"
                :hint="hint"
                persistent-hint
                :style="style_text_field"
            >
            </v-text-field>

            <v-btn
              icon
              class="icon-button"
              v-on:click="onStyleOp('increase-font-size')"
            >
              <v-icon>mdi-format-font-size-increase</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onStyleOp('decrease-font-size')"
            >
              <v-icon>mdi-format-font-size-decrease</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onClickSetFontSize"
            >
              <v-icon>mdi-format-size</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onStyleOp('toggle-bold')"
            >
              <v-icon>mdi-format-bold</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onStyleOp('toggle-italic')"
            >
              <v-icon>mdi-format-italic</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onStyleOp('toggle-underline')"
            >
              <v-icon>mdi-format-underline</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onClickSetFontFamily"
            >
              <v-icon>mdi-format-font</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onClickSetFontColor"
            >
              <v-icon>mdi-palette</v-icon>
            </v-btn>
            <v-btn
              icon
              class="icon-button"
              v-on:click="onClickSpace"
            >
              <v-icon>mdi-keyboard-space</v-icon>
            </v-btn>
            
            <v-btn
              icon
              class="icon-button"
              v-on:click="onStyleOp('toggle-show')"
            >
              <v-icon>{{toggle_show_icon}}</v-icon>
            </v-btn>

            <v-btn
              icon
              class="icon-button"
              v-on:click="onClickResetStyle"
            >
              <v-icon>mdi-restore</v-icon>
            </v-btn>
            
        </div>

        <m-edit-css-property-dialog
            ref="edit-css-property-dialog"
            v-on:modify="onModify"
        />

        
    </div>


</div>
</template>

<script>
export default {
    props: {

        label: {
            type: String,
            default: function() { return 'Label'; }
        },

        value: {
            type: Object,
            default: function() { return {'text': null, 'style': 'font-size: 14px'}; }
        },

        hint: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            css_property_dialog_label: null,
            css_property_dialog_property_name: null,
        }
    },

    created() {
    },

    methods: {
        onChangeText()
        {
            this.$emit('input', this.value);
        },

        onStyleOp(op, ex_params)
        {
            ex_params = ex_params ?? {};

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/inline/modify',
            
                'params' : {
                        'inline_style': this.value.style,
                        'op': op,
                        ...ex_params,
                    },
            
                'on_success': (data) => {
                        this.$emit('input', {
                            'text': this.value.text,
                            'style': data.inline_style,
                            'default_style': this.value.default_style,
                        });
                    },
            
                'on_error': 'Unable to adjust style',
            });
        },

        onClickSetFontSize()
        {
            this.css_property_dialog_label = 'Font Size';
            this.css_property_dialog_property_name = 'font-size';

            this.onClickSetCSSProperty();
        },

        onClickSpace()
        {
            this.css_property_dialog_label = 'Spacing (Padding)';
            this.css_property_dialog_property_name = 'padding';

            

            this.onClickSetCSSProperty( 
                {
                    "name": "padding",
                    "value": {
                        "type": "directional",
                        "raw_value": "0px 0px 0px 0px",
                        "red": null,
                        "green": null,
                        "blue": null,
                        "alpha": null,
                        "magnitude": null,
                        "unit": null,
                        "left": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "right": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "top": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "bottom": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "values": []
                    },
                    "default_value": {
                        "type": "directional",
                        "raw_value": "0px 0px 0px 0px",
                        "red": null,
                        "green": null,
                        "blue": null,
                        "alpha": null,
                        "magnitude": null,
                        "unit": null,
                        "left": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "right": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "top": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "bottom": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "values": []
                    }
                    }
            );
        },

        onClickSetFontColor()
        {
            this.css_property_dialog_label = 'Text Color';
            this.css_property_dialog_property_name = 'color';

            this.onClickSetCSSProperty();
        },

        onClickSetFontFamily()
        {
            this.css_property_dialog_label = 'Font Family';
            this.css_property_dialog_property_name = 'font-family';

            this.onClickSetCSSProperty();
        },

        onClickSetCSSProperty(default_value)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/inline/parse',
            
                'params' : {
                        'inline_style': this.value.style,
                        'default_inline_style': this.value.default_style,
                    },
            
                'on_success': (data) => {

                        let value = data.properties
                            .find(el => el.name == this.css_property_dialog_property_name);

                        value = value ?? default_value;

                        this.$refs['edit-css-property-dialog'].showDialog({
                            'label': this.css_property_dialog_label, 
                            'property_name': this.css_property_dialog_property_name,
                            'value': value, 
                        });
                    },
            
                'on_error': 'Unable to get property value',
            });
        },

        onModify(operation)
        {
            this.onStyleOp(operation.op, {'property_name': operation.property_name, 'value': operation.value});
        },
        
        onClickResetStyle()
        {
            this.$rc.confirm({
                'title': 'Reset to Default Formatting',
                'body': 'Are you sure that you want to reset the style of this text to the default?<br/><br/>This can not be undone.',
                'btn_text_ok': 'Reset',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doResetStyle();
                },
            });
        },

        doResetStyle()
        {
            this.value.style = this.value.default_style;
            this.$emit('input', this.value);
        },
    },

    computed: {
        style_text_field() {
            if ( this.hint == null ) 
                return null;

            return 'margin-bottom: 15px;'
        },

        toggle_show_icon()
        {
            let style = '';

            if ( this.value != null && this.value.style != null )
                style = this.value.style;

            if ( style.toLowerCase().includes('display: none') )
                return 'mdi-eye';

            return 'mdi-eye-off';
        },
    },
}
</script>

<style lang="scss" scoped>
.checker
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    background-image: url('https://files.redchirp.com/dcf69ef7-2e39-4bcd-b0ca-cd4be32eeff2.webp'); 
    background-size: cover; 
    background-position: center;
    background-repeat: no-repeat;

    z-index: 1;
}

.swatch
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    z-index: 2;
}

.icon-button
{
    margin-top: -15px;
    margin-bottom: 15px;
}

</style>